/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { Locale } from "@cosmos/hygraph-schema";

const hygraphLocaleMapping: { [key: string]: string } = {
	zh_hant: "zh_tw",
};

/**
 *
 * The lang parameter can be any of the locales from the locales array in the i18n config.
 *
 * This should return a valid locale code in the hygraphLocales array from the i18n config.
 *
 * @param lang
 * @returns
 */
export const getHygraphLocale = (hygraphLocales: string[], lang: string): string => {
	if (lang) {
		const adjustedLang = lang?.toLowerCase().replace("-", "_");
		const mappedLang = hygraphLocaleMapping[adjustedLang] || adjustedLang;

		const matchedLocale = hygraphLocales.find((locale) => mappedLang === locale.toLowerCase());
		return matchedLocale || Locale.En;
	}

	return Locale.En;
};
